import { ProgramsListPage } from '@components/buzzkuri/pages/ProgramsList'
import { ProgramsListPageRes } from '@type/buzzkuri/programs'
import React from 'react'
import { GetServerSidePropsContext } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { getPagePropsReq } from '@utils/http'
import { BuzzkuriHead } from '@components/buzzkuri/shared/common/BuzzkuriHead'
import { ErrorStatus } from '@type/common'
import { ErrorPage } from '@components/buzzkuri/shared/common/ErrorPage'
import {
  NOT_FOUND_PAGE_PROPS,
  INTERNAL_SERVER_ERROR_PAGE_PROPS,
} from '@constants/common'
import { MAX_DISPLAY_ITEMS_NUMBER } from '@constants/buzzkuri/programs'
import { MetaData } from '@type/buzzkuri/api'

const Programs = (
  props: (ProgramsListPageRes & { searchWord: string }) | ErrorStatus
): JSX.Element => (
  <>
    {'errorStatus' in props ? (
      <ErrorPage
        {...(props.errorStatus === 404
          ? NOT_FOUND_PAGE_PROPS
          : INTERNAL_SERVER_ERROR_PAGE_PROPS)}
      />
    ) : (
      <>
        <BuzzkuriHead
          metaData={(props as ProgramsListPageRes).metaData as MetaData}
        />
        <ProgramsListPage
          {...(props as ProgramsListPageRes)}
          slugs={`search?searchWord=${
            (props as ProgramsListPageRes & { searchWord: string }).searchWord
          }`}
        />
      </>
    )}
  </>
)
export default Programs

export async function getServerSideProps(
  context: GetServerSidePropsContext<ParsedUrlQuery>
): Promise<
  | {
      props: (ProgramsListPageRes & { searchWord: string }) | ErrorStatus
    }
  | { redirect: { destination: string; permanent: boolean } }
> {
  const { searchWord } = context.query
  const { page } = context.query
  // 検索ワードがない場合はプログラムトップページへ遷移
  if (!searchWord || !(searchWord as string).match(/\S/g)) {
    return {
      redirect: {
        destination: '/programs',
        permanent: false,
      },
    }
  }
  const props = (await getPagePropsReq(
    context,
    `/api/programs/?searchWord=${encodeURI(searchWord as string)}&page=${
      page ? page : 1
    }&maxDisplayItemsNumber=${MAX_DISPLAY_ITEMS_NUMBER}`,
    `「${searchWord}」と関連するプログラム`
  )) as {
    props: ProgramsListPageRes | ErrorStatus
  }

  return {
    props: {
      ...props.props,
      searchWord: searchWord as string,
    },
  }
}
